import React, { useState } from "react";

function Footer() {
  return (
    <div>
      <footer class="footer font-small blue mt-5">
        <h5 class="text-center pt-3 mb-0 fw-bold">Cineview © 2022</h5>
        <div class="text-center py-2">
          A website for reviewing and watchlisting the latest movies.
        </div>
        <div class="text-center pb-3 font-monospace">
          Made with ❤ by Zain and Omar
        </div>
      </footer>
    </div>
  );
}

export default Footer;
